import currency from '@/data/currency.json'

export default {
  currency: currency,
}
